const path = 'https://api.edamam.com/search';

export default path;